// export const host = 'http://localhost:3080';
export const host = process.env.REACT_APP_CHAT_URL;
export const logoutRoute = `${host}/api/auth/logout`;
export const sendMessageRoute = `${host}/api/messages/addmsg`;
export const recieveMessageRoute = `${host}/api/messages/getmsg`;

//AVATAR
// export const avatarApi = 'https://api.multiavatar.com';
export const avatarApi = process.env.REACT_APP_AVATAR_URL;
